import dynamicImageImporter from '../../utils/dynamicImageImporter.js';
import ImageStepper from '../ImageStepper/ImageStepper.js';
import { GooglePlayButton, AppStoreButton } from "react-mobile-app-button";
import 'react-social-icons/twitter';
import 'react-social-icons/youtube';
import 'react-social-icons/instagram';
import './GameList.css';

const staticImages = dynamicImageImporter(require.context('/public/art/static', false));
const bannerImages = dynamicImageImporter(require.context('/public/art/banners', false));
const apkUrl = "https://BlueHoneyStudios.com";
const iosUrl = "https://BlueHoneyStudios.com";
const steps = [
  {
    img: staticImages['screenshot_0']
  },
  {
    img: staticImages['screenshot_1']
  },
  {
    img: staticImages['screenshot_2']
  },
  {
    img: staticImages['screenshot_3']
  }
];

function GameList(){
    return(
        [
            <div className="GameList-Container">
                <img src={bannerImages['impureChessBanner']} className="GameList-Background" alt="ImpureChessBanner"/>
                <img src={bannerImages['impureChessLogo']} className="GameList-ImpureChessLogo" alt="ImpureChessLogo"/>
                <img src={bannerImages['impureChessKnight']} className="GameList-KnightImage" alt="KnightChessPiece"/>
                <div className="GameList-ImpureChess-ImageStepper-Container">
                    <ImageStepper steps={steps}/>
                </div>
                <div className="GameList-Button-Container">
                    <div className="GameList-Button">
                        <GooglePlayButton url={apkUrl} theme="dark" height={45} width={250} />
                    </div>
                    <div className="GameList-Button">
                        <AppStoreButton url={iosUrl} theme="dark" height={45} width={250} />
                    </div>
                </div>
            </div>,
            <div className="GameList-Container">
                <img src={bannerImages['impureArenaBanner']} className="GameList-Background" alt="ImpureArenaBanner"/>
                <img src={staticImages['comingSoon']} className="GameList-ComingSoon" alt="ImpureArenaBanner"/>
                <img src={bannerImages['impureArenaLogo']} className="GameList-ImpureArenaLogo" alt="ImpureArenaLogo"/>
            </div>
        ]
    );
}

export default GameList;